export const HOUSE_START_SCREEN = 'HOUSE_START_SCREEN'
export const HOUSE_MAIN_VIEW = 'HOUSE_MAIN_VIEW'
export const HOUSE_INNER_VIEW = 'HOUSE_INNER_VIEW'
export const HOUSE_LIST_VIEW = 'HOUSE_LIST_VIEW'
export const HOUSE_THANKS_VIEW = 'HOUSE_THANKS_VIEW'
export const HOUSE_STATE = 'HOUSE_STATE'
export const STATE_SELECT_VIEW = 'STATE_SELECT_VIEW'


